export default [
  // 拜访模块
  {
    path: '/customer/visit-record/create-normal',
    name: 'CustomerVisitRecordCreateNormal',
    component: () => import(/* webpackChunkName: 'CustomerVisitRecordCreateNormal' */ '@/views/customer/visit-record/create-normal.vue'),
    meta: {
      title: '新增常规拜访记录',
    },
  },
  {
    path: '/customer/visit-record/edit-normal',
    name: 'CustomerVisitRecordEditNormal',
    component: () => import(/* webpackChunkName: 'CustomerVisitRecordEditNormal' */ '@/views/customer/visit-record/edit-normal.vue'),
    meta: {
      title: '修改常规拜访记录',
    },
  },
  {
    path: '/customer/visit-record/detail-normal',
    name: 'CustomerVisitRecorddDetailNormal',
    component: () => import(/* webpackChunkName: 'CustomerVisitRecorddDetailNormal' */ '@/views/customer/visit-record/detail-normal.vue'),
    meta: {
      title: '常规拜访记录详情',
    },
  },
  {
    path: '/customer/visit-record/create-finance',
    name: 'CustomerVisitRecordCreateFinance',
    component: () => import(/* webpackChunkName: 'CustomerVisitRecorddDetailNormal' */ '@/views/customer/visit-record/create-finance.vue'),
    meta: {
      title: '新增金融拜访记录',
    },
  },
  {
    path: '/customer/visit-record/edit-finance',
    name: 'CustomerVisitRecordEditFinance',
    component: () => import(/* webpackChunkName: 'CustomerVisitRecordEditFinance' */ '@/views/customer/visit-record/edit-finance.vue'),
    meta: {
      title: '修改金融拜访记录',
    },
  },
  {
    path: '/customer/visit-record/detail-finance',
    name: 'CustomerVisitRecordDetailFinance',
    component: () => import(/* webpackChunkName: 'CustomerVisitRecordDetailFinance' */ '@/views/customer/visit-record/detail-finance.vue'),
    meta: {
      title: '金融拜访记录详情',
    },
  },

  // 陪访模块
  {
    path: '/customer/accompany-record/create-normal',
    name: 'CustomerAccompanyRecordNormal',
    component: () => import(/* webpackChunkName: 'CustomerAccompanyRecordNormal' */ '@/views/customer/accompany-record/create-normal.vue'),
    meta: {
      title: '新增常规陪访计划',
    },
  },
  {
    path: '/customer/accompany-record/edit-normal',
    name: 'CustomerAccompanyEditNormal',
    component: () => import(/* webpackChunkName: 'CustomerAccompanyEditNormal' */ '@/views/customer/accompany-record/edit-normal.vue'),
    meta: {
      title: '修改常规陪访',
    },
  },
  {
    path: '/customer/accompany-record/detail-normal',
    name: 'CustomerAccompanyRecordDetailNormal',
    component: () => import(/* webpackChunkName: 'CustomerAccompanyRecordDetailNormal' */ '@/views/customer/accompany-record/detail-normal.vue'),
    meta: {
      title: '常规陪访详情',
    },
  },
  {
    path: '/customer/accompany-record/create-finance',
    name: 'CustomerAccompanyRecordCreateFinance',
    component: () => import(/* webpackChunkName: 'CustomerAccompanyRecordCreateFinance' */ '@/views/customer/accompany-record/create-finance.vue'),
    meta: {
      title: '新增金融陪访计划',
    },
  },
  {
    path: '/customer/accompany-record/edit-finance',
    name: 'CustomerAccompanyRecordEditFinance',
    component: () => import(/* webpackChunkName: 'CustomerAccompanyRecordEditFinance' */ '@/views/customer/accompany-record/edit-finance.vue'),
    meta: {
      title: '修改金融陪访',
    },
  },
  {
    path: '/customer/accompany-record/detail-finance',
    name: 'CustomerAccompanyRecordDetailFinance',
    component: () => import(/* webpackChunkName: 'CustomerAccompanyRecordDetailFinance' */ '@/views/customer/accompany-record/detail-finance.vue'),
    meta: {
      title: '金融陪访详情',
    },
  },
];
